"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppPage = exports.setAppVersionForDisplay = void 0;
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const react_1 = __importDefault(require("react"));
const AppHeader_1 = __importDefault(require("../AppHeader"));
const nav_1 = __importDefault(require("../nav"));
let version;
const setAppVersionForDisplay = (newVersion) => (version = newVersion);
exports.setAppVersionForDisplay = setAppVersionForDisplay;
exports.AppPage = react_1.default.memo((props) => {
    const { children, busy = false } = props;
    return (react_1.default.createElement(Horizontal_1.default, { stretch: true },
        react_1.default.createElement(nav_1.default, null),
        react_1.default.createElement(Vertical_1.default, { style: { overflow: 'hidden' } },
            react_1.default.createElement(AppHeader_1.default, { version: version }),
            react_1.default.createElement(Spinner_1.default, { busy: busy }, children))));
});
exports.default = exports.AppPage;
